import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormGroup} from "@angular/forms";
import {Field} from "../../models";
import {SubSink} from "@Common/core/utils/subsink";
import {LdapUser} from "@Services/ldap/ldap/ldap-user.model";
import {MatRadioChange} from "@angular/material/radio";
import {AvisObject, Sollicite} from "../../models/avis-object";

@Component({
  selector: 'app-form-render-avis',
  templateUrl: './form-render-avis.component.html',
  styleUrls: ['./form-render-avis.component.scss']
})
export class FormRenderAvisComponent implements OnInit {
  @Input() formGroup: UntypedFormGroup;
  @Input() item: Field;
  blockFormName = '';
  subSink = new SubSink();
  scope = false;
  defaultScopes = '';
  scopesToDisplay = ['employee', 'faculty', 'researcher', 'student'];
  avis_obj = <AvisObject>{avis:'',avis_observation:'',sollicite:<Sollicite>{}};
  mode_sollicite = false;
  constructor() { }

  ngOnInit(): void {
    this.blockFormName = `block-${this.item.block}`;
    if(this.formGroup.value){
      if(this.formGroup.value[this.blockFormName][this.item.id] && this.formGroup.value[this.blockFormName][this.item.id]['sollicite']['display_name']){
        this._populateAvisValue();
      }
    }

  }

  onSelectIndiv(ldapUser: LdapUser) {
    this.avis_obj.sollicite.display_name = ldapUser.displayName[0];
    this.avis_obj.sollicite.mail = ldapUser.mail[0];
    this.avis_obj.sollicite.user_name = ldapUser.uid[0];
    this.formGroup.controls[this.blockFormName].patchValue({[this.item.key] :this.avis_obj});
  }

  deleteIndiv(): void {
    this._clearSollicite();
  }

  setAvisValue(event: MatRadioChange): void {
    this.avis_obj.avis = event.value;
  }

  private _clearSollicite(): void {
    this.avis_obj.sollicite = <Sollicite>{};
  }

  private _populateAvisValue(): void {
    this.avis_obj = this.formGroup.value[this.blockFormName][this.item.id];
  }

}
